export const UPLOAD_FILE = 'UPLOAD_FILE';